/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

/* ICONS */
import { IoCall, IoMail } from "react-icons/io5";

const OfficeLocation = () => {
  return (
    <motion.div variants={animation} className="p-0 relative">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.668249166919!2d-118.10044042400581!3d33.872439673225266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dd2d6f26e55555%3A0xe2051aaa3233ac05!2s11050%20Artesia%20Blvd%20Suite%20C%2C%20Cerritos%2C%20CA%2090703%2C%20USA!5e0!3m2!1sen!2sin!4v1741086627113!5m2!1sen!2sin"
        className="w-full h-[35vh]"
        title="Office Location"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>

      <div className="relative xl:absolute lg:absolute top-0 right-0 xl:right-20 lg:right-20 h-full">
        <div className="container h-full maps">
          <div className="ml-auto w-full xl:w-[35vh] lg:w-[35vh] h-full bg-[#323232] bg-opacity-90 px-5 py-5 xl:py-0 lg:py-0 flex flex-col justify-center">
            {/* WORKING HOURS */}
            <div className="p-0">
              <h5 className="text-lg font-source font-bold text-white">
                WORKING HOURS
              </h5>
              <div className="mt-3">
                <div className="pb-1.5 border-b border-white border-opacity-40">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-source font-normal text-white">
                      Mon - Fri
                    </p>
                    <p className="text-sm font-source font-medium text-white">
                      9:00 AM - 8:00 PM
                    </p>
                  </div>
                </div>
                <div className="mt-3 pb-1.5 border-b border-white border-opacity-40">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-source font-normal text-white">
                      Sat and Sun
                    </p>
                    <p className="text-sm font-source font-medium text-white">
                      10:30 AM - 10:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* REACH US VIA */}
            <div className="mt-7">
              <h5 className="text-lg font-source font-bold text-white">
                REACH US VIA
              </h5>
              <div className="mt-3">
                <div className="group flex items-center gap-2">
                  <IoCall className="w-4 h-4 text-white group-hover:text-red-300 flex-shrink-0 transition-all duration-300 ease-in-out" />
                  <a
                    href="tel:+15622023427"
                    className="block text-sm font-source font-normal text-white group-hover:text-red-300 transition-all duration-300 ease-in-out"
                  >
                    +1 (562) 202-3427
                  </a>
                </div>
                <div className="mt-2 group flex items-center gap-2">
                  <IoMail className="w-4 h-4 text-white group-hover:text-red-300 flex-shrink-0 transition-all duration-300 ease-in-out" />
                  <a
                    href="mailto:surepassbook@gmail.com"
                    className="block text-sm font-source font-normal text-white group-hover:text-red-300 transition-all duration-300 ease-in-out"
                  >
                    surepassbook@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default OfficeLocation;
